
import { defineComponent, ref, watch, watchEffect } from 'vue'
import { useFormModule } from '@/modules/_shared/forms'
import QForm from 'quasar/src/components/form/QForm.js';
import { useBillingTemplateModule } from '@/modules/billing-templates'
import EditableField from '@/components/_shared/editable-field.vue'

export default defineComponent({
    name: 'billing-templates-editable-field-payment-terms',
    components: { EditableField },
    props: {
        modelValue: {
            type: Number,
            required: true
        },
        organizationId: {
            type: String,
            required: true
        },
        billingTemplateId: {
            type: String,
            required: true
        }
    },
    setup (props, { emit }) {
        const { updatePaymentTerms } = useBillingTemplateModule()
        const { submitForm, createOnSuccess } = useFormModule()
        const localValue = ref<number>(props.modelValue)
        const form = ref<QForm>()

        watchEffect(() => {
            localValue.value = props.modelValue
        })

        watch(localValue, () => {
            const paymentTerms = typeof localValue.value === 'string' ? parseInt(localValue.value) : localValue.value
            submitForm(
                form.value,
                async () => updatePaymentTerms(props.organizationId, props.billingTemplateId,
                    {
                        organizationId: props.organizationId,
                        billingTemplateId: props.billingTemplateId,
                        paymentTerms: paymentTerms
                    }),
                () => {
                    emit('update:modelValue', localValue.value)
                    createOnSuccess('Billing template payment terms updated')()
                }
            )
        })

        return {
            localValue,
            form
        }
    }
})
